export const BACKEND_API_URL = 'https://dmenezes16--speechcraft-backend-wsgi-factory.modal.run';
export const STRIPE_CUSTOMER_PORTAL_URL = process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_URL;
export const STRIPE_PLUS_PLAN_PAYMENT_URL = process.env.REACT_APP_STRIPE_PLUS_PLAN_PAYMENT_URL;